import { Root, route } from '../utils';

const clientMeetingRoomsPath = `${Root}client-meeting-rooms`;

export default {
  clientMeetingRooms: {
    ...route(clientMeetingRoomsPath),
  },
};
